import { render, staticRenderFns } from "./equipmentDetail.vue?vue&type=template&id=84b6dd30&scoped=true&"
import script from "./equipmentDetail.vue?vue&type=script&lang=js&"
export * from "./equipmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./equipmentDetail.vue?vue&type=style&index=0&id=84b6dd30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b6dd30",
  null
  
)

export default component.exports